<div aria-labelledby="universityCampusModal"
     class="modal fade in universityCampusModal"
     id="universityCampusModal"
     role="dialog"
     tabindex="-1"
>
  <div class="modal-dialog modal-xl"
       role="document"
  >
    <div class="modal-content">
      <div class="modal-header">
        <button (click)="close()"
                aria-label="Close"
                class="close"
                data-cy="campus-modal-close-x"
                data-dismiss="modal"
                type="button"
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row text-center">
          <div class="col-md-12"
               data-cy="campus-modal-container"
          >
            <div class="col-md-10 offset-md-1 text-box">
              <div [attr.data-preview-id]="'#' + headline?.name"
                   [id]="'headline-' + id"
                   [innerHTML]="headline?.value | safeHtml"
                   data-cy="campus-modal-headline"
                   class="campus-modal-headline"
                   mbCmsInnerHTML
              ></div>
              <div [attr.data-preview-id]="'#' + description?.name"
                   [id]="'description-' + id"
                   [innerHTML]="description?.value | safeHtml"
                   data-cy="campus-modal-description"
                   class="campus-modal-description"
                   mbCmsInnerHTML
              ></div>
            </div>
            <div class="col-md-12 img-box spacer-top">
              <mb-link [linkData]="{uid: cmsLinkType.SPECIAL, text: buttonText}"
                       [styleClass]="['btn', 'btn-lg', 'btn-primary']"
                       (click)="close()"
                       aria-label="Close"
                       dataCy="campus-modal-close-button"
                       data-dismiss="modal"
                       mbCmsInnerHTML
              ></mb-link>
              <img [alt]="'shared.campusModalImageTags' | cxTranslate"
                   [title]="'shared.campusModalImageTags' | cxTranslate"
                   class="img-responsive"
                   src="/assets/images/macs-campus.png"
                   mbCmsInnerHTML
              >
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</div>
